// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__19Uf8","body":"Modal_body__2zKnE","icon":"Modal_icon__2b2nF","title":"Modal_title__2UV9G","desc":"Modal_desc__1Yrde","btn":"Modal_btn__1tNTp"};